import { render, staticRenderFns } from "./ShadowAttrsItem.vue?vue&type=template&id=b10b6bda&"
import script from "./ShadowAttrsItem.vue?vue&type=script&lang=js&"
export * from "./ShadowAttrsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("I:\\web-project\\dream\\tools\\dsf-product-ppt\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b10b6bda')) {
      api.createRecord('b10b6bda', component.options)
    } else {
      api.reload('b10b6bda', component.options)
    }
    module.hot.accept("./ShadowAttrsItem.vue?vue&type=template&id=b10b6bda&", function () {
      api.rerender('b10b6bda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/components/attr/items/ShadowAttrsItem.vue"
export default component.exports